import { render, staticRenderFns } from "./GenericTableAction.vue?vue&type=template&id=0897f856&scoped=true"
import script from "./GenericTableAction.vue?vue&type=script&lang=js"
export * from "./GenericTableAction.vue?vue&type=script&lang=js"
import style0 from "./GenericTableAction.vue?vue&type=style&index=0&id=0897f856&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0897f856",
  null
  
)

export default component.exports